import { ExternalLinkIcon } from 'lucide-react'
import {
  parseSearchTrustedWebSourcesOutput,
  truncatePlainTextForUi,
} from './llmChatToolOutput'

export type LlmChatToolWebSourcesProps = {
  output: unknown
  emptyLabel: string
  failedLabel: string
  searchedSourcesLabel: string
  openLinkLabel: string
}

export function LlmChatToolWebSources({
  output,
  emptyLabel,
  failedLabel,
  searchedSourcesLabel,
  openLinkLabel,
}: LlmChatToolWebSourcesProps) {
  const parsed = parseSearchTrustedWebSourcesOutput(output)
  if (!parsed) {
    return null
  }

  if (parsed.items.length === 0) {
    const showFailed = parsed.failed === true
    const showSearchedSources =
      !showFailed && parsed.searchedSources.length > 0
    let statusLabel = emptyLabel
    if (showFailed) {
      statusLabel = failedLabel
    }

    return (
      <div className='border-t border-border/40 px-3 py-2'>
        {showSearchedSources ? (
          <div className='mb-2'>
            <p className='text-[11px] font-medium text-muted-foreground'>
              {searchedSourcesLabel}
            </p>
            <ul className='mt-1 list-disc space-y-0.5 pl-4 text-[11px] text-muted-foreground'>
              {parsed.searchedSources.map((source) => (
                <li key={source.domain}>{source.displayName}</li>
              ))}
            </ul>
          </div>
        ) : null}
        <p className='text-[12px] text-muted-foreground'>{statusLabel}</p>
      </div>
    )
  }

  return (
    <div className='border-t border-border/40 px-3 py-2'>
      <div className='space-y-2'>
        {parsed.items.map((item, itemIndex) => (
          <article
            key={`${item.url}-${itemIndex}`}
            className='rounded-md border border-border bg-background p-2'
          >
            <header className='mb-1.5 flex flex-wrap items-start justify-between gap-x-2 gap-y-1'>
              <div className='min-w-0 flex-1'>
                <div className='line-clamp-2 text-[12px] leading-snug font-semibold text-foreground'>
                  {item.title}
                </div>
                <div className='mt-0.5 text-[10px] text-muted-foreground'>
                  {item.sourceDisplayName}
                </div>
              </div>
              <a
                href={item.url}
                target='_blank'
                rel='noreferrer noopener'
                className='inline-flex shrink-0 items-center gap-1 text-xs underline-offset-2 hover:underline'
              >
                {openLinkLabel}
                <ExternalLinkIcon className='size-3' />
              </a>
            </header>
            <p className='line-clamp-4 text-xs leading-relaxed text-muted-foreground'>
              {truncatePlainTextForUi(item.snippet, 200)}
            </p>
          </article>
        ))}
      </div>
    </div>
  )
}
